export const BaseUrlQuranCloudApi = "https://api.alquran.cloud/v1/";

export enum EndpointListExteral {
  PAGE = "page/",
  // LANGUAGE = "ar.asad",
  LANGUAGE = "quran-uthmani",
  AYAH = "ayah",
  LANGUAGE_ALAFASY = "ar.alafasy",
}
